import React from 'react';
import { withTheme } from 'styled-components';
import { observer } from 'mobx-react';
import { inject } from '../../../../utils';
import { AlertProps, AlertThemeKeys } from './Models';
import { ThemeableComponent } from '../../../../utils/theme/ThemeableComponent';
import Modal from '../../../Modal';
import Translate from '../../../../Components/Translate';
import { computed } from 'mobx';
import { FeedbackType } from '../Toast/Models';

@inject('feedbackStore')
@observer
class Alert extends ThemeableComponent<AlertProps, {}, AlertThemeKeys> {
    DEFAULT_THEME_KEYS: AlertThemeKeys = {
        action: 'AlertActionButton',
        header: 'AlertHeaderWrapper',
        title: 'AlertTitle',
        titleBar: 'AlertTitleBar',
        wrapper: 'AlertWrapper',
    };

    @computed
    get title() {
        const { feedbackStore } = this.props;
        const { alertMessage } = feedbackStore;
        if (alertMessage) {
            const { feedbackType, title } = alertMessage;
            let titleText = title;
            if (!titleText) {
                switch (feedbackType) {
                    case FeedbackType.success:
                        titleText = 'Success';
                        break;
                    case FeedbackType.error:
                        titleText = 'Error';
                        break;
                    case FeedbackType.warning:
                        titleText = 'Warning';
                        break;
                    case FeedbackType.info:
                    default:
                        titleText = 'Info';
                        break;
                }
            }
            return titleText;
        }
    }

    render() {
        const { feedbackStore } = this.props;
        if (!feedbackStore) {
            return null;
        }

        let autoRemoveAlert;

        if (feedbackStore.hasAlertFeedback) {
            const { alertOptions } = feedbackStore?.alertMessage?.config;
            const autoClose =
                alertOptions?.autoClose !== undefined
                    ? alertOptions.autoClose
                    : false;
            const displaySeconds = alertOptions?.displaySeconds || 3;
            if (autoClose) {
                autoRemoveAlert = setTimeout(() => {
                    feedbackStore.removeAlert();
                }, displaySeconds * 1000);
            }
        }

        const headerContent = (
            <Translate>{feedbackStore.alertMessage?.text}</Translate>
        );

        return (
            <Modal
                modalId={'fundcenter-modal-feedback'}
                title={this.title}
                headerContent={headerContent as any}
                bodyContent={null}
                footerContent={null}
                isOpen={feedbackStore.hasAlertFeedback}
                expanderButtonProps={{
                    disable: true,
                }}
                actions={[
                    {
                        id: 'okButton',
                        label: 'Okay',
                        type: 'close',
                    },
                ]}
                closeButtonProps={{
                    disable: true,
                }}
                onClose={() => {
                    clearTimeout(autoRemoveAlert);
                    feedbackStore.removeAlert();
                }}
                themeKeys={this.DEFAULT_THEME_KEYS}
            />
        );
    }
}

export default withTheme(Alert) as any;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Alert/Alert.tsx